<div class="w-100 h-100">
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="search()"></i>
                                {{$t('shared.templatesRenewalRequests')}} ({{requestsCount}})
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row align-items-start w-100">
                        <div class="col">
                            <div class="form-row flex-md-nowrap">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.displayId"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.displayId')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.templateName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.templateName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.senderName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.senderNameSearch')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <input class="form-control border-right-0 border-left"
                                               type="text"
                                               v-model="filterModel.clientName"
                                               @input="onInputSearch"
                                               :placeholder="$t('dashboardPage.clientName')" />
                                        <div class="input-group-append">
                                            <span class="input-group-text right gray">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-3">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <v-data-table :headers="headers"
                                  :items="requests"
                                  :total-items="requestsCount"
                                  :pagination="pagination"
                                  :loading="isLoading"
                                  @update:pagination="updatePaginate"
                                  :rows-per-page-text="$t('shared.rowsPerPage')"
                                  :rows-per-page-items="[10, 25, 50, 100]"
                                  item-key="id"
                                  class="elevation-1 table-striped">
                        <template v-slot:headers="props">
                            <tr>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)" :width="header.width !== '' ? header.width : ''">
                                    <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr>
                                <td class="text-center">{{ props.item.displayId }}</td>
                                <td class="text-center">{{ props.item.templateName }}</td>
                                <td class="text-center">{{ props.item.senderName }}</td>
                                <td class="text-center">{{ props.item.clientName }}</td>
                                <td class="text-center">{{ props.item.classification }}</td>
                                <td class="text-center">{{ props.item.createdDate }}</td>
                                <td class="text-center">
                                    <div class="status_txt" :style="{ color: getStatusColor(props.item) }">{{ getStatusText(props.item) }}</div>
                                </td>
                                <td class="text-center btn_menu">
                                    <v-menu offset-y open-on-hover>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="btn-primary" v-on="on">
                                                <div>{{$t('shared.actions')}}</div>
                                                <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile v-if="canPay(props.item)" @click="pay(props.item.id)">
                                                <v-list-tile-title class="white">{{$t('dashboardPage.Pay')}}</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile v-if="!canPay(props.item)" @click="details(props.item.id)">
                                                <v-list-tile-title class="white">{{$t('dashboardPage.details')}}</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:no-data>
                            <div class="text-center w-100">
                                {{ loadFailed ? $t('shared.errorOccurred') : $t('shared.noDataAvailable') }}
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </div>
    </div>
</div>
